import { useState } from "react";
import { css } from "../../../styled-system/css";
import { Flex } from "../../../styled-system/jsx";
import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../../zodios/client";
import { TextField } from "../../components/fields/base/TextField";
import { Button } from "../../components/core/basic/Button";
import { successToast } from "../../utils/toasts";
import { Link } from "@tanstack/react-router";
import { AuthLayout } from "../../layouts/AuthLayout";
import { useTranslation } from "react-i18next";

function ForgetPassForm() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [emailSent, setEmailSent] = useState(false);
  const { t } = useTranslation("auth");

  const requestPasswordResetMutation = useMutation({
    mutationFn: async () => {
      await apiClient.requestPasswordReset({
        email: email.toLowerCase().trim(),
      });
    },
    onError: (error) => {
      if (typeof error.message === "string") {
        setError(error.message);
      } else {
        setError(t(($) => $.auth.forgotPassword["Something went wrong sending password reset email."]));
      }
    },
    onSuccess: () => {
      successToast({
        message: t(
          ($) =>
            $.auth.forgotPassword["Reset password email successfully sent. Please check for inbox for next steps."],
        ),
      });
      setEmailSent(true);
    },
  });

  return (
    <AuthLayout
      title={t(($) => $.auth.forgotPassword["Forgot your password?"])}
      subtitle={t(
        ($) => $.auth.forgotPassword["Enter your email and you'll receive instructions to reset your password."],
      )}
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          requestPasswordResetMutation.mutate();
        }}
      >
        <Flex gap={"medium"} direction={"column"}>
          <TextField
            label={t(($) => $.auth.forgotPassword.Email)}
            type={"email"}
            onChange={(value) => {
              setEmail(value);
            }}
          />
        </Flex>
        <Button
          isPending={requestPasswordResetMutation.isPending}
          isDisabled={!email.trim().length}
          className={css({ width: "100%", marginTop: "large" })}
          type="submit"
        >
          {t(($) => $.auth.forgotPassword["Send Reset Password Link"])}
        </Button>
      </form>
      <div className={css({ width: "100%", marginTop: "medium", textAlign: "center" })}>
        <Link to="/">{t(($) => $.auth.forgotPassword["Sign In Instead"])}</Link>
      </div>
      {error && <p className={css({ paddingY: "large", textAlign: "center" })}>{error}</p>}
      {emailSent && (
        <p className={css({ paddingY: "large", fontSize: "small", textAlign: "center" })}>
          {t(($) => $.auth.forgotPassword["An email has been sent to the provided email address."])}
        </p>
      )}
    </AuthLayout>
  );
}

export default ForgetPassForm;
